import { useState } from 'react'
import { Box, LinearProgress, SvgIcon, Tab, Tabs } from '@mui/material'
import { ModelListRowModel } from '~/features/models/models-list/types'
import { EmptyState } from '~/ui/components/EmptyState'
import { SimpleDrawer } from '~/ui/components/SimpleDrawer'
import { ModelDetails } from './ModelDetails'
import { IconAlertCircle } from '@tabler/icons-react'
import { InventoryDetails } from './InventoryDetails'
import { SalesDetails } from './SalesDetails'
import { ActionsHistory } from './ActionsHistory'

type DetailDrawerProps = {
  open: boolean
  onClose: () => void
  data: ModelListRowModel | null
  isLoading?: boolean
}

export const DetailDrawer = ({ open, onClose, data, isLoading }: DetailDrawerProps) => {
  const [tabIndex, setTabIndex] = useState(0)
  const handleClose = () => {
    setTabIndex(0)
    onClose()
  }
  return (
    <SimpleDrawer title="Detail Drawer" open={open} onClose={handleClose}>
      {isLoading ? (
        <LinearProgress />
      ) : data ? (
        <>
          <Tabs value={tabIndex} onChange={(_, value) => setTabIndex(value)} variant="fullWidth">
            <Tab
              label="Model Details"
              icon={
                data.warnings?.some((el) => el.key === 'inconsistent_shopify_product_id') ? (
                  <SvgIcon fontSize="small" color="warning">
                    <IconAlertCircle />
                  </SvgIcon>
                ) : undefined
              }
              sx={{ whiteSpace: 'nowrap' }}
              iconPosition="start"
            />
            <Tab
              label="Inventory"
              icon={
                data.warnings?.some(
                  (el) =>
                    el.key === 'inconsistent_shopify_price' || el.key === 'missing_shopify_size'
                ) ? (
                  <SvgIcon fontSize="small" color="warning">
                    <IconAlertCircle />
                  </SvgIcon>
                ) : undefined
              }
              sx={{ whiteSpace: 'nowrap' }}
              iconPosition="start"
            />
            <Tab label="Sales" sx={{ whiteSpace: 'nowrap' }} />
            <Tab label="Actions History" sx={{ whiteSpace: 'nowrap' }} />
          </Tabs>
          <Box sx={{ pt: 2, overflow: 'hidden', flexGrow: 1 }}>
            {tabIndex === 0 && <ModelDetails data={data} />}
            {tabIndex === 1 && <InventoryDetails data={data} />}
            {tabIndex === 2 && <SalesDetails data={data} />}
            {tabIndex === 3 && <ActionsHistory data={data} />}
          </Box>
        </>
      ) : (
        <EmptyState
          title="Inventory can't be found"
          text="Close the drawer and re-open by clicking on an item in the list"
        />
      )}
    </SimpleDrawer>
  )
}
